export default __webpack_public_path__ + "static/media/Ballroll_00069.74da737f.png";